// src/components/ErrorMessage.jsx
import PropTypes from "prop-types";
import React from "react";

const ErrorMessage = ({ errorMessage = "Something went wrong.", onRetry }) => {
  return (
    <div
      className="d-flex flex-column gap-3 justify-content-center align-items-center text-center"
      style={{ minHeight: "100vh" }}
      role="alert"
      aria-live="polite"
    >
      <p className="m-0">{errorMessage}</p>
      {onRetry && (
        <button type="button" className="btn btn-primary" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
};

ErrorMessage.propTypes = {
  errorMessage: PropTypes.string,
  onRetry: PropTypes.func, // optional
};

export default ErrorMessage;
